import {
  Error,
  ADD_ADMIN_REQUEST,
  UPDATE_ADMIN_REQUEST,
  DELETE_ADMIN_REQUEST,
  GET_ADMIN_REQUEST,
  GET_REMAINING_ADMIN_REQUEST,
} from "../type";
const initialState = {
  AddAdminRequest: [],
  GetAdminRequest: [],
  GetRemainingAdminRequest: [],
  UpdateAdminRequest: [],
  DeleteAdminRequest: [],
};
const AdminRequestR = (state = initialState, action) => {
  switch (action.type) {
    case GET_ADMIN_REQUEST:
      return {
        ...state,
        GetAdminRequest: action.payload,
      };
          case GET_REMAINING_ADMIN_REQUEST:
      return {
        ...state,
        GetRemainingAdminRequest: action.payload,
      };
    case ADD_ADMIN_REQUEST:
      return {
        GetAdminRequest: state.GetAdminRequest,
        AddAdminRequest: action.payload,
      };
    case UPDATE_ADMIN_REQUEST:
      return {
        GetAdminRequest: state.GetAdminRequest,
        UpdateAdminRequest: action.payload,
      };
    case DELETE_ADMIN_REQUEST:
      return {
        GetAdminRequest: state.GetAdminRequest,
        DeleteAdminRequest: action.payload,
      };
    case Error:
      return {
        GetAdminRequest: action.payload,
      };
    default:
      return state;
  }
};
export default AdminRequestR;
